export { DirectionsDiamond as default } from './DirectionsDiamond';
